import styled from "styled-components";
import { Flex } from "@rebass/grid";

export const ShareContainer = styled(Flex)`
  button {
    padding: 0 !important;
    outline: none !important;
  }
`;
